import { compose } from 'recompose';
import { connect } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import orderSelectors from 'state/order/selectors';

import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';

import LegalInfo from 'components/summary/LegalInfo/component';

const enhance = compose(
  connect((state) => ({
    conditionsUrl: settingsSelectors.getLegalLinks(state).terms_and_conditions,
    insuranceUrl: settingsSelectors.getLegalLinks(state).insurance,
    hasInsurance:
      orderSelectors
        .getExtras(state)
        .indexOf(aditionalOptionsConstants.ADITIONAL_OPTIONS.INSURANCE) >= 0,
  }))
);

export default enhance(LegalInfo);
